import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { InviteGate } from "@/components/InviteGate";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <InviteGate>
      <App />
    </InviteGate>
  </React.StrictMode>,
);
